var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.crumbs.length
    ? _c("v-breadcrumbs", {
        staticClass: "app-breadcrumbs pa-0",
        attrs: { items: _vm.crumbs, divider: "/" },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function (ref) {
                var item = ref.item
                return [
                  item.type === "link"
                    ? _c(
                        "router-link",
                        {
                          staticClass: "crumb crumb--link",
                          attrs: { to: item.to },
                        },
                        [
                          _vm._v(
                            "\n      " +
                              _vm._s(item.raw ? item.text : _vm.$t(item.text)) +
                              "\n    "
                          ),
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "crumb",
                          class: { "crumb--current": item.type === "current" },
                        },
                        [
                          _vm._v(
                            "\n      " +
                              _vm._s(item.raw ? item.text : _vm.$t(item.text)) +
                              "\n    "
                          ),
                        ]
                      ),
                ]
              },
            },
          ],
          null,
          false,
          501960996
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }